module.exports = __webpack_public_path__ + "static/media/29DUNON3.3c6a8cfd.jpg";